import Footer from "../component/Footer";
import Header from "../component/Header";
import { Link, useLocation, useParams } from "react-router-dom";
import ScrollToTop from "../component/ScrollToTop";

export default function BlogDetail() {
  const id = useLocation();
  console.log(id.state.id, "id");
  return (
    <>
      <ScrollToTop>
        <Header />
        <div className="breadcumb-wrapper style2 bg-smoke">
          <div className="container">
            <div className="row">
              <div className="col-lg-6">
                <div className="breadcumb-content justify-content-center">
                  <ul className="breadcumb-menu">
                    <li>
                      <a href="/">Home</a>
                    </li>
                    <li>
                      <a href="blog">Blog</a>
                    </li>
                    <li>What You Should Know About Web3</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* blog-details-area */}
        <section className="blog__details-area space">
          <div className="container">
            <div className="blog__inner-wrap">
              <div className="row justify-content-center">
                <div className="col-70">
                  <div className="blog__details-wrap">
                    <div className="blog__details-thumb">
                      <img src="./images/blog/blog_details01.jpg" alt="img" />
                    </div>
                    <div className="blog__details-content">
                      <div className="blog-post-meta">
                        <ul className="list-wrap">
                          <li>March 26, 2024</li>
                          <li>
                            <a href="blog.html">Branding</a>
                          </li>
                          <li>
                            <a href="blog.html">by Ashton Porter</a>
                          </li>
                        </ul>
                      </div>
                      <h2 className="title">What You Should Know About Web3</h2>
                      <p>
                        HopeFly Meta is proud to support businesses stepping
                        into the world of Web3. We recently partnered with
                        several startups to guide their entry into blockchain
                        technology and build digital solutions that are
                        decentralized, secure, and user-owned.
                      </p>
                      <p>
                        Web3 offers a new way for people to use the internet—one
                        where users control their data, own digital assets like
                        NFTs, and can transact without intermediaries. As early
                        adopters begin to build in this space, we’ve helped
                        shape strategies that combine simple UX with powerful,
                        future-ready tech.
                      </p>
                      <blockquote>
                        <img
                          className="blockquote-icon"
                          src="./images/icon/quote.svg"
                          alt="img"
                        />
                        <p>
                          “Working with HopeFly Meta made Web3 easier to
                          understand. Their team guided us from idea to
                          execution—and now our users are loving it.” — Web3
                          Product Owner, Tech Startup
                        </p>
                      </blockquote>
                      <p>
                        This shift isn’t about jumping on a trend—it’s about
                        preparing for the next generation of internet
                        experiences. Businesses today are using Web3 tools to
                        boost customer loyalty, secure transactions, and offer
                        new forms of engagement.
                      </p>

                      <div className="blog__details-inner">
                        <div className="row align-items-center">
                          <div className="col-sm-6">
                            <div className="blog__details-inner-thumb">
                              <img
                                src="./images/blog/blog_details02.jpg"
                                alt="img"
                              />
                            </div>
                          </div>
                          <div className="col-sm-6">
                            <div className="blog__details-inner-thumb">
                              <img
                                src="./images/blog/blog_details03.jpg"
                                alt="img"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <p>
                        By staying flexible and focusing on user value, we’ve
                        helped make Web3 approachable—even exciting—for both
                        small and large companies looking to build smarter
                        online ecosystems.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="wrapper">
          <div class="marquee marquee-wrap">
            <div class="marquee_group">
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="/service">
                    <i className="fas fa-star-of-life" />
                    Business Branding
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Web Development
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Cloud-based Application
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    AI Solution
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Metaverse Solution
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Marketing and SEO
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Web Service
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    E-commerce Plugin
                  </Link>
                </h6>
              </div>
            </div>
            <div aria-hidden="ture" class="marquee_group">
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="/service">
                    <i className="fas fa-star-of-life" />
                    Business Branding
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Web Development
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Cloud-based Application
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    AI Solution
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Metaverse Solution
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Marketing and SEO
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    Web Service
                  </Link>
                </h6>
              </div>
              <div className="inner">
                <h6 className="item m-item m-0">
                  <Link to="#">
                    <i className="fas fa-star-of-life" />
                    E-commerce Plugin
                  </Link>
                </h6>
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </ScrollToTop>
    </>
  );
}
